<template>
<div class="container-gallery">
    <div id="home" class="animated-topbutton tamanhoicon" @click="$emit('backToMenu'); somback()">
        <img :src="require('@/assets/buttons/newbuttons/black/home.svg')" />
    </div>
    <h1 class="title title-black">{{$t('menu.gallery.title')}}</h1>
    <div class="button-list-gallery">
        <button class="tamanho0" :class="[selected_game == 'melody' ? 'button-gallery-selected': 'button-gallery']" @click="selected_game = 'melody'; somclick()">
            {{$t('menu.gallery.melody')}}</button>
        <button class="tamanho0" :class="[selected_game == 'dance' ? 'button-gallery-selected': 'button-gallery']" @click="selected_game = 'dance'; somclick()">
            {{$t('menu.gallery.dance')}}
        </button>
        <button class="tamanho0" :class="[selected_game == 'rhythm' ? 'button-gallery-selected': 'button-gallery']" @click="selected_game = 'rhythm'; somclick()">
            {{$t('menu.gallery.rhythm')}}</button>
        <button class="tamanho0" :class="[selected_game == 'sing' ? 'button-gallery-selected': 'button-gallery']" @click="selected_game = 'sing'; somclick()">
            {{$t('menu.gallery.sing')}}</button>
    </div>
    <!--  Lista de Saves -->
    <div class='container-center-horizontal-gallery'>
        <div v-if="selected_game in games" class='button-video-list color-list-gallery'>
            <div v-for="save in games[selected_game]" :key="save.game_id" class='playlist-video-list color-gallery tamanho0'>
                <span v-if="save.title != ''" :class="'musicName-video-list' + ' ' + selected_game"> {{save.title}} ({{save.game_id}}) </span>
                <span v-else :class="'musicName-video-list' + ' ' + selected_game"> {{$t('menu.gallery.melody')}} {{save.game_id}} </span>
                <img :src="require('@/assets/backgrounds/' + selected_game + '.png')" class='videogallery'/>
                <span @click="videoPlay(save)" class="tamanhoicon">
                    <img v-if="videopause || current_game.game_id != save.game_id" :src="require('@/assets/buttons/newbuttons/gallery/play.svg')" />
                    <img v-else :src="require('@/assets/buttons/newbuttons/gallery/pause.svg')" />
                </span>
            </div>
        </div>
        <div v-else class="button-video-list color-list-gallery gallery-no-saves">
            <p>{{$t('menu.gallery.no_games_of_type')}} <b>{{$t('menu.gallery.' + selected_game)}}</b></p>
            <p>{{$t('menu.gallery.try_creating_game')}}</p>
        </div>
    </div>
    <MelodySave v-if="selected_game == 'melody' && !videopause" :saved_game="current_game" @editScore="console.log('e')" @backToMenu="$emit('backToMenu')" @backToGallery="videopause = !videopause; current_game = {}"/>
    <RhythmSave v-if="selected_game == 'rhythm' && !videopause" :saved_game="current_game" @editScore="console.log('e')" @backToMenu="$emit('backToMenu')" @backToGallery="videopause = !videopause; current_game = {}"/>
    <DancingSave v-if="selected_game == 'dance' && !videopause" :saved_game="current_game" @editScore="console.log('e')" @backToMenu="$emit('backToMenu')" @backToGallery="videopause = !videopause; current_game = {}"/>
    <SingingSave v-if="selected_game == 'sing' && !videopause" :saved_game="current_game" @editScore="console.log('e')" @backToMenu="$emit('backToMenu')" @backToGallery="videopause = !videopause; current_game = {}"/>
</div>
</template>

<script>
import MelodySave from "@/components/GalleryView/MelodySave.vue";
import DancingSave from "@/components/GalleryView/DancingSave.vue";
import SingingSave from "@/components/GalleryView/SingingSave.vue";
import RhythmSave from "@/components/GalleryView/RhythmSave.vue";

export default {
    name: "Gallery",
    emits: ["backToMenu"],
    components: {
        MelodySave,
        RhythmSave,
        DancingSave,
        SingingSave
    },
    data() {
        return {
            videos: [],
            videopause: true,
            games: {},
            selected_game: 'melody',
            current_game: null
        };
    },
    props: {
        somTeclas: Boolean,
        user: Object
    },
    methods: {
        somback() {
            if (this.somTeclas) {
                this.back.play();
            }
        },
        somclick() {
            if (this.somTeclas) {
                this.click.play();
            }
        },
        videoPlay(game) {
            this.somclick();
            this.current_game = game;
            this.videopause = !this.videopause;
        },
        getGamesFromUser() {
            fetch(process.env.VUE_APP_API_URL + "/getGamesUser?user_id=" + this.user['id'], {
                    headers: {
                        "Access-Control-Allow-Origin": "*",
                        "Access-Control-Allow-Headers": "*",
                        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                        Accept: "application/json, text/plain, *//**",
                    },
                    method: "GET",
                })
                .then((res) => {
                    return res.json();
                })
                .then((devs) => {
                    this.games = devs;
                })
                .catch((error) => {
                    console.log(error);
                    error = true;
                });
        }
    },
    created() {
        if (this.characterselected != '') {
            this.selected = this.characterselected;
            this.selectedString = this.selected;
        }
    },
    mounted() {
        this.click = new Audio(require('@/assets/sons/click.wav'));
        this.back = new Audio(require('@/assets/sons/back.flac'));

        this.getGamesFromUser();
    },
};
</script>

<style>
#videogallery, img.videogallery {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: -10;
    border-radius: 20px;
    top: 0;
}

.title-black {
    color: black;
}

.container-gallery {
    pointer-events: none;
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
    height: 100%;
    font-family: Omnes;
    font-style: normal;
}

.container-gallery>img {
    width: 100%;
    height: 100%;
    z-index: -1;
    object-fit: cover;
}

.container-gallery>* {
    pointer-events: auto;
    flex-shrink: 0;
}

.container-options-gallery {
    width: 40%;
    position: absolute;
    top: 35%;
    left: 17%;
    display: flex;
    justify-content: space-around;
    font-size: 1.2em;
    font-weight: bold;
    animation: movecontainergallery 0.5s ease-in-out;
    flex-direction: column;
}

.gallery-no-saves {
    grid-template-columns: repeat(1, 80%) !important;
}

@keyframes movecontainergallery {
    0% {
        left: -10%;
    }

    100% {
        left: 17%;
    }
}

.container-options-gallery>span {
    padding-bottom: 4%;
}

.label-gallery {
    margin-left: 4%;
}

.button-list-gallery {
    position: absolute;
    top: 29%;
    width: 29%;
    left: 10%;
    display: flex;
    justify-content: space-evenly;
    animation: movecontainerbuttonsgallery 0.5s ease-in-out;
    flex-direction: column;
}

@keyframes movecontainerbuttonsgallery {
    0% {
        right: -10%;
    }

    100% {
        right: 3%;
    }
}

.button-gallery {
    background-color: rgba(255, 255, 255);
    border: black 3px solid;
    border-radius: 80px;
    padding: 0.5rem;
    margin-bottom: 4%;
    font-family: Omnes;
    font-weight: bold;
    width: 57%;
}

.button-gallery-selected {
    background-color: black;
    border: black 3px solid;
    border-radius: 80px;
    padding: 0.5rem;
    margin-bottom: 4%;
    color: white;
    font-family: Omnes;
    font-weight: bold;
    width: 57%;
}

/* ----------------------  Galeria  ----------------------  */

.button-video-list {
    position: absolute;
    left: 0;
    top: 30%;
    width: 65%;
    height: 58%;
    display: grid;
    overflow: scroll;
    text-align: center;
    justify-content: center;
    grid-template-columns: repeat(2, 40%);
    grid-template-rows: repeat(10, 52%);
    grid-gap: 2.5%;
    row-gap: 8.5%;
    margin-left: 25%;
}

.playlist-video-list {
    background: rgba(255, 255, 255, 0.7);
    border-radius: 30px;
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
    /* display: grid; */
    display: flex;
    padding: 4% 4% 2% 4%;
    font-family: Omnes;
    font-weight: bold;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
}

.musicName-video-list {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-size: medium;
    font-weight: bold;
}

.musicName-video-list.dance, .musicName-video-list.sing, .musicName-video-list.rhythm {
    color: white;
}

.sel-gallery {
    background: rgba(191, 200, 255, 0.7) !important;
}

.color-list-gallery::-webkit-scrollbar {
    width: 10px;
    height: 100%;
}

.color-list-gallery::-webkit-scrollbar-track {
    background: rgba(221, 221, 221, 0.7);
    border-radius: 10px;
}

.color-list-gallery::-webkit-scrollbar-thumb {
    background: #000000;
    border-radius: 10px;
}

@media only screen and (max-width: 480px) {
    .container-options-gallery {
        font-size: 0.8rem;
    }

    .tamanho0 {
        font-size: 0.4rem;
    }

    .switch {
        width: 45px;
        height: 28px;
    }

    .slider:before {
        height: 15px;
        width: 15px;
    }

    input:checked+.slider:before {
        -webkit-transform: translateX(15px);
        -ms-transform: translateX(15px);
        transform: translateX(15px);
    }

    .language {
        width: 66px;
        height: 28px;
    }

    .language>span>img {
        height: 15px;
        width: 15px;
    }

    .language>span {
        font-size: 0.4rem;
    }

    .button-video-list {

        height: 40%;

    }
}

@media only screen and (min-width: 480px) and (max-width: 550px) {
    .container-options-gallery {
        font-size: 0.9rem;
    }

    .tamanho0 {
        font-size: 0.5rem;
    }

    .switch {
        width: 49px;
        height: 30px;
    }

    .slider:before {
        height: 17px;
        width: 17px;
    }

    input:checked+.slider:before {
        -webkit-transform: translateX(17px);
        -ms-transform: translateX(17px);
        transform: translateX(17px);
    }

    .language {
        width: 78px;
        height: 30px;
    }

    .language>span>img {
        height: 17px;
        width: 17px;
    }

    .language>span {
        font-size: 0.5rem;
    }
}

@media only screen and (min-width: 550px) and (max-width: 630px) {
    .container-options-gallery {
        font-size: 1rem;
    }

    .tamanho0 {
        font-size: 0.6rem;
    }

    .switch {
        width: 53px;
        height: 32px;
    }

    .slider:before {
        height: 19px;
        width: 19px;
    }

    input:checked+.slider:before {
        -webkit-transform: translateX(19px);
        -ms-transform: translateX(19px);
        transform: translateX(19px);
    }

    .language {
        width: 88px;
        height: 32px;
    }

    .language>span>img {
        height: 19px;
        width: 19px;
    }

    .language>span {
        font-size: 0.6rem;
    }
}

@media only screen and (min-width: 630px) and (max-width: 718px) {
    .container-options-gallery {
        font-size: 1.1rem;
    }

    .tamanho0 {
        font-size: 0.7rem;
    }

    .switch {
        width: 57px;
        height: 34px;
    }

    .slider:before {
        height: 21px;
        width: 21px;
    }

    input:checked+.slider:before {
        -webkit-transform: translateX(21px);
        -ms-transform: translateX(21px);
        transform: translateX(21px);
    }

    .language {
        width: 104px;
        height: 34px;
    }

    .language>span>img {
        height: 21px;
        width: 21px;
    }

    .language>span {
        font-size: 0.7rem;
    }
}

@media only screen and (min-width: 718px) and (max-width: 806px) {
    .container-options-gallery {
        font-size: 1.2rem;
    }

    .tamanho0 {
        font-size: 0.8rem;
    }

    .switch {
        width: 61px;
        height: 36px;
    }

    .slider:before {
        height: 23px;
        width: 23px;
    }

    input:checked+.slider:before {
        -webkit-transform: translateX(23px);
        -ms-transform: translateX(23px);
        transform: translateX(23px);
    }

    .language {
        width: 118px;
        height: 36px;
    }

    .language>span>img {
        height: 23px;
        width: 23px;
    }

    .language>span {
        font-size: 0.8rem;
    }
}

@media only screen and (min-width: 806px) and (max-width: 1024px) {
    .container-options-gallery {
        font-size: 1.3rem;
    }

    .tamanho0 {
        font-size: 0.9rem;
    }

    .switch {
        width: 65px;
        height: 38px;
    }

    .slider:before {
        height: 25px;
        width: 25px;
    }

    input:checked+.slider:before {
        -webkit-transform: translateX(25px);
        -ms-transform: translateX(25px);
        transform: translateX(25px);
    }

    .language {
        width: 120px;
        height: 38px;
    }

    .language>span>img {
        height: 25px;
        width: 25px;
    }

    .language>span {
        font-size: 0.9rem;
    }
}

@media only screen and (min-width: 1024px) and (max-width: 1200px) {
    .container-options-gallery {
        font-size: 1.4rem;
    }

    .tamanho0 {
        font-size: 1rem;
    }

    .switch {
        width: 68px;
        height: 40px;
    }

    .slider:before {
        height: 27px;
        width: 27px;
    }

    input:checked+.slider:before {
        -webkit-transform: translateX(27px);
        -ms-transform: translateX(27px);
        transform: translateX(27px);
    }

    .language {
        width: 129px;
        height: 40px;
    }

    .language>span>img {
        height: 27px;
        width: 27px;
    }

    .language>span {
        font-size: 1rem;
    }
}

@media only screen and (min-width: 1200px) and (max-width: 1366px) {
    .container-options-gallery {
        font-size: 1.6rem;
    }

    .tamanho0 {
        font-size: 1.2rem;
    }

    .switch {
        width: 71px;
        height: 42px;
    }

    .slider:before {
        height: 29px;
        width: 29px;
    }

    input:checked+.slider:before {
        -webkit-transform: translateX(29px);
        -ms-transform: translateX(29px);
        transform: translateX(29px);
    }

    .language {
        width: 139px;
        height: 42px;
    }

    .language>span>img {
        height: 29px;
        width: 29px;
    }

    .language>span {
        font-size: 1.1rem;
    }
}

@media only screen and (min-width: 1366px) and (max-width: 1540px) {
    .container-options-gallery {
        font-size: 1.8rem;
    }

    .tamanho0 {
        font-size: 1.4rem;
    }

    .switch {
        width: 74px;
        height: 44px;
    }

    .slider:before {
        height: 31px;
        width: 31px;
    }

    input:checked+.slider:before {
        -webkit-transform: translateX(31px);
        -ms-transform: translateX(31px);
        transform: translateX(31px);
    }

    .language {
        width: 155px;
        height: 44px;
    }

    .language>span>img {
        height: 31px;
        width: 31px;
    }

    .language>span {
        font-size: 1.3rem;
    }
}

@media only screen and (min-width: 1540px) and (max-width: 1680px) {
    .container-options-gallery {
        font-size: 2rem;
    }

    .tamanho0 {
        font-size: 1.6rem;
    }

    .switch {
        width: 78px;
        height: 46px;
    }

    .slider:before {
        height: 33px;
        width: 33px;
    }

    input:checked+.slider:before {
        -webkit-transform: translateX(33px);
        -ms-transform: translateX(33px);
        transform: translateX(33px);
    }

    .language {
        width: 172px;
        height: 46px;
    }

    .language>span>img {
        height: 33px;
        width: 33px;
    }

    .language>span {
        font-size: 1.4rem;
    }
}

@media only screen and (min-width: 1680px) and (max-width: 2350px) {
    .container-options-gallery {
        font-size: 2.2rem;
    }

    .tamanho0 {
        font-size: 1.8rem;
    }

    .switch {
        width: 82px;
        height: 48px;
    }

    .slider:before {
        height: 35px;
        width: 35px;
    }

    input:checked+.slider:before {
        -webkit-transform: translateX(35px);
        -ms-transform: translateX(35px);
        transform: translateX(35px);
    }

    .language {
        width: 182px;
        height: 48px;
    }

    .language>span>img {
        height: 35px;
        width: 35px;
    }

    .language>span {
        font-size: 1.5rem;
    }
}

@media only screen and (min-width: 2350px) and (max-width: 2550px) {
    .container-options-gallery {
        font-size: 2.4rem;
    }

    .tamanho0 {
        font-size: 2rem;
    }

    .switch {
        width: 86px;
        height: 50px;
    }

    .slider:before {
        height: 37px;
        width: 37px;
    }

    input:checked+.slider:before {
        -webkit-transform: translateX(37px);
        -ms-transform: translateX(37px);
        transform: translateX(37px);
    }

    .language {
        width: 206px;
        height: 50px;
    }

    .language>span>img {
        height: 40px;
        width: 40px;
    }

    .language>span {
        font-size: 1.8rem;
    }
}

@media only screen and (min-width: 2550px) {
    .container-options-gallery {
        font-size: 4rem;
    }

    .tamanho0 {
        font-size: 3.6rem;
    }

    .switch {
        width: 183px;
        height: 100px;
    }

    .slider.round {
        border-radius: 50px;
    }

    .slider:before {
        height: 83px;
        width: 83px;
    }

    input:checked+.slider:before {
        -webkit-transform: translateX(83px);
        -ms-transform: translateX(83px);
        transform: translateX(83px);
    }

    .language {
        width: 348px;
        height: 100px;
        border-radius: 50px;
    }

    .language>span>img {
        height: 83px;
        width: 83px;
    }

    .language>span {
        font-size: 3rem;
    }
}
</style>
